import { render, staticRenderFns } from "./DocumentHistoryList.vue?vue&type=template&id=7e43f657&"
import script from "./DocumentHistoryList.vue?vue&type=script&lang=js&"
export * from "./DocumentHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports